//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param fileTypeId (optional) 
     * @param lastName (optional) 
     * @param agentId (optional) 
     * @param insuredId (optional) 
     * @param companyId (optional) 
     * @param workFlowType (optional) 
     * @param insuredName (optional) 
     * @param workflowStatusId (optional) 
     * @param isIncludeInactiveCarrier (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllWorkflowDocuments(v: string, fileTypeId?: number | undefined, lastName?: string | null | undefined, agentId?: number | null | undefined, insuredId?: number | null | undefined, companyId?: number | null | undefined, workFlowType?: ShowWorkFlowType | undefined, insuredName?: string | null | undefined, workflowStatusId?: number | null | undefined, isIncludeInactiveCarrier?: boolean | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<WorkflowDocumentSearchRepsonse> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (fileTypeId === null)
            throw new Error("The parameter 'fileTypeId' cannot be null.");
        else if (fileTypeId !== undefined)
            url_ += "FileTypeId=" + encodeURIComponent("" + fileTypeId) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (agentId !== undefined && agentId !== null)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (insuredId !== undefined && insuredId !== null)
            url_ += "InsuredId=" + encodeURIComponent("" + insuredId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (workFlowType === null)
            throw new Error("The parameter 'workFlowType' cannot be null.");
        else if (workFlowType !== undefined)
            url_ += "WorkFlowType=" + encodeURIComponent("" + workFlowType) + "&";
        if (insuredName !== undefined && insuredName !== null)
            url_ += "InsuredName=" + encodeURIComponent("" + insuredName) + "&";
        if (workflowStatusId !== undefined && workflowStatusId !== null)
            url_ += "WorkflowStatusId=" + encodeURIComponent("" + workflowStatusId) + "&";
        if (isIncludeInactiveCarrier === null)
            throw new Error("The parameter 'isIncludeInactiveCarrier' cannot be null.");
        else if (isIncludeInactiveCarrier !== undefined)
            url_ += "IsIncludeInactiveCarrier=" + encodeURIComponent("" + isIncludeInactiveCarrier) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllWorkflowDocuments(_response);
        });
    }

    protected processGetAllWorkflowDocuments(response: Response): Promise<WorkflowDocumentSearchRepsonse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkflowDocumentSearchRepsonse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkflowDocumentSearchRepsonse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createWorkflowDocument(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateWorkflowDocumentModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateWorkflowDocument(_response);
        });
    }

    protected processCreateWorkflowDocument(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param id (optional) 
     * @param fName (optional) 
     * @param lName (optional) 
     * @param agentId (optional) 
     * @param typeId (optional) 
     * @param companyId (optional) 
     * @param marketerAgentId (optional) 
     * @param uplineAgentId (optional) 
     * @param assignedToUserId (optional) 
     * @param assignedToTeamId (optional) 
     * @param productId (optional) 
     * @param notes (optional) 
     * @param appDate (optional) 
     * @param flag (optional) 
     * @param fileName (optional) 
     * @return Success
     */
    updateWorkflowDocument(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, id?: number | undefined, fName?: string | null | undefined, lName?: string | null | undefined, agentId?: number | null | undefined, typeId?: number | undefined, companyId?: number | null | undefined, marketerAgentId?: number | null | undefined, uplineAgentId?: number | null | undefined, assignedToUserId?: number | null | undefined, assignedToTeamId?: number | null | undefined, productId?: number | null | undefined, notes?: string | null | undefined, appDate?: Date | null | undefined, flag?: string | null | undefined, fileName?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (fName !== null && fName !== undefined)
            content_.append("FName", fName.toString());
        if (lName !== null && lName !== undefined)
            content_.append("LName", lName.toString());
        if (agentId !== null && agentId !== undefined)
            content_.append("AgentId", agentId.toString());
        if (typeId === null || typeId === undefined)
            throw new Error("The parameter 'typeId' cannot be null.");
        else
            content_.append("TypeId", typeId.toString());
        if (companyId !== null && companyId !== undefined)
            content_.append("CompanyId", companyId.toString());
        if (marketerAgentId !== null && marketerAgentId !== undefined)
            content_.append("MarketerAgentId", marketerAgentId.toString());
        if (uplineAgentId !== null && uplineAgentId !== undefined)
            content_.append("UplineAgentId", uplineAgentId.toString());
        if (assignedToUserId !== null && assignedToUserId !== undefined)
            content_.append("AssignedToUserId", assignedToUserId.toString());
        if (assignedToTeamId !== null && assignedToTeamId !== undefined)
            content_.append("AssignedToTeamId", assignedToTeamId.toString());
        if (productId !== null && productId !== undefined)
            content_.append("ProductId", productId.toString());
        if (notes !== null && notes !== undefined)
            content_.append("Notes", notes.toString());
        if (appDate !== null && appDate !== undefined)
            content_.append("AppDate", appDate.toJSON());
        if (flag !== null && flag !== undefined)
            content_.append("Flag", flag.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWorkflowDocument(_response);
        });
    }

    protected processUpdateWorkflowDocument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param productId (optional) 
     * @param documentTypeId (optional) 
     * @param assignedToUserId (optional) 
     * @param assignedToTeamId (optional) 
     * @param workflowStatusId (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    searchWorkflowDocumentByQueue(v: string, companyId?: number | null | undefined, productId?: number | null | undefined, documentTypeId?: number | null | undefined, assignedToUserId?: number | null | undefined, assignedToTeamId?: number | null | undefined, workflowStatusId?: number | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<WorkflowDocumentSearchRepsonse> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/searchbyqueue?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (productId !== undefined && productId !== null)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (documentTypeId !== undefined && documentTypeId !== null)
            url_ += "DocumentTypeId=" + encodeURIComponent("" + documentTypeId) + "&";
        if (assignedToUserId !== undefined && assignedToUserId !== null)
            url_ += "AssignedToUserId=" + encodeURIComponent("" + assignedToUserId) + "&";
        if (assignedToTeamId !== undefined && assignedToTeamId !== null)
            url_ += "AssignedToTeamId=" + encodeURIComponent("" + assignedToTeamId) + "&";
        if (workflowStatusId === null)
            throw new Error("The parameter 'workflowStatusId' cannot be null.");
        else if (workflowStatusId !== undefined)
            url_ += "WorkflowStatusId=" + encodeURIComponent("" + workflowStatusId) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchWorkflowDocumentByQueue(_response);
        });
    }

    protected processSearchWorkflowDocumentByQueue(response: Response): Promise<WorkflowDocumentSearchRepsonse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkflowDocumentSearchRepsonse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkflowDocumentSearchRepsonse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getWorkflowDocumentById(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<WorkflowDocumentDetailModel> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkflowDocumentById(_response);
        });
    }

    protected processGetWorkflowDocumentById(response: Response): Promise<WorkflowDocumentDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkflowDocumentDetailModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    deleteWorkflowDocument(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: DeleteWorkflowDocumentModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteWorkflowDocument(_response);
        });
    }

    protected processDeleteWorkflowDocument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteFileInReceivedQueue(v: string, fileName?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/deletefromreceivedqueue?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteFileInReceivedQueue(_response);
        });
    }

    protected processDeleteFileInReceivedQueue(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getWorkflowDocumentsByAgentId(id: number, v: string, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<WorkflowDocumentSearchRepsonse> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/agents/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkflowDocumentsByAgentId(_response);
        });
    }

    protected processGetWorkflowDocumentsByAgentId(response: Response): Promise<WorkflowDocumentSearchRepsonse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkflowDocumentSearchRepsonse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkflowDocumentSearchRepsonse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getWorkflowDocumentCountByAgentId(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/agentdocumentcount/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkflowDocumentCountByAgentId(_response);
        });
    }

    protected processGetWorkflowDocumentCountByAgentId(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllWorkflowStatusLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/workflowstatuslookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllWorkflowStatusLookup(_response);
        });
    }

    protected processGetAllWorkflowStatusLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllTypeLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/typelookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllTypeLookup(_response);
        });
    }

    protected processGetAllTypeLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllDivisionLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/divisionlookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllDivisionLookup(_response);
        });
    }

    protected processGetAllDivisionLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllWorkflowLookUps(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<LookupDetailModel> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/alllookups";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllWorkflowLookUps(_response);
        });
    }

    protected processGetAllWorkflowLookUps(response: Response): Promise<LookupDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookupDetailModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupDetailModel>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getWorkflowDocumentCount(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<WorkflowDocumentCountResponse> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/count";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkflowDocumentCount(_response);
        });
    }

    protected processGetWorkflowDocumentCount(response: Response): Promise<WorkflowDocumentCountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkflowDocumentCountResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkflowDocumentCountResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllWorkflowNotes(documentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<WorkflowNotesResponse> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/{documentId}/notes";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllWorkflowNotes(_response);
        });
    }

    protected processGetAllWorkflowNotes(response: Response): Promise<WorkflowNotesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkflowNotesResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createWorkflowDocumentNotes(documentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: AddDocumentNoteModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/{documentId}/notes";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateWorkflowDocumentNotes(_response);
        });
    }

    protected processCreateWorkflowDocumentNotes(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    downloadFileInReceivedQueue(v: string, fileName?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DownloadFileInReceivedQueueModel> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/downloadfile?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadFileInReceivedQueue(_response);
        });
    }

    protected processDownloadFileInReceivedQueue(response: Response): Promise<DownloadFileInReceivedQueueModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadFileInReceivedQueueModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadFileInReceivedQueueModel>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    downloadWorkflowDocument(documentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DownloadWorkflowDocumentModel> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/{documentId}/download";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadWorkflowDocument(_response);
        });
    }

    protected processDownloadWorkflowDocument(response: Response): Promise<DownloadWorkflowDocumentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadWorkflowDocumentModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadWorkflowDocumentModel>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentContactEmails(documentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentContactEmailsResponse> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/{documentId}/agentcontactemails";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentContactEmails(_response);
        });
    }

    protected processGetAgentContactEmails(response: Response): Promise<AgentContactEmailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentContactEmailsResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getLicenseCommunications(documentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<LicenseCommunicationsResponse> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/{documentId}/licensecommunications";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLicenseCommunications(_response);
        });
    }

    protected processGetLicenseCommunications(response: Response): Promise<LicenseCommunicationsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseCommunicationsResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    sendToComments(documentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: AddSendToCommentsModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/{documentId}/sendto";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendToComments(_response);
        });
    }

    protected processSendToComments(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param file (optional) 
     * @return Success
     */
    uploadWorkflowDocument(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, file?: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/upload";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadWorkflowDocument(_response);
        });
    }

    protected processUploadWorkflowDocument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param file (optional) 
     * @param existingFileName (optional) 
     * @return Success
     */
    replaceReceivedDocument(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, file?: FileParameter | null | undefined, existingFileName?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/replacereceiveddocument";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (existingFileName !== null && existingFileName !== undefined)
            content_.append("ExistingFileName", existingFileName.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReplaceReceivedDocument(_response);
        });
    }

    protected processReplaceReceivedDocument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param file (optional) 
     * @param location (optional) 
     * @param notes (optional) 
     * @return Success
     */
    attachWorkflowDocument(documentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, file?: FileParameter | null | undefined, location?: LocationType | undefined, notes?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/{documentId}/attach";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (location === null || location === undefined)
            throw new Error("The parameter 'location' cannot be null.");
        else
            content_.append("Location", location.toString());
        if (notes !== null && notes !== undefined)
            content_.append("Notes", notes.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAttachWorkflowDocument(_response);
        });
    }

    protected processAttachWorkflowDocument(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param file (optional) 
     * @param location (optional) 
     * @param notes (optional) 
     * @return Success
     */
    replaceWorkflowDocument(documentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, file?: FileParameter | null | undefined, location?: LocationType | undefined, notes?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/{documentId}/replace";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (location === null || location === undefined)
            throw new Error("The parameter 'location' cannot be null.");
        else
            content_.append("Location", location.toString());
        if (notes !== null && notes !== undefined)
            content_.append("Notes", notes.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReplaceWorkflowDocument(_response);
        });
    }

    protected processReplaceWorkflowDocument(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    duplicateWorkflowDocument(documentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: DuplicateWorkflowDocumentModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/{documentId}/duplicate";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDuplicateWorkflowDocument(_response);
        });
    }

    protected processDuplicateWorkflowDocument(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param isSteal (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    updateFileInReceivedQueue(v: string, fileName?: string | null | undefined, isSteal?: boolean | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/updatefile?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (isSteal === null)
            throw new Error("The parameter 'isSteal' cannot be null.");
        else if (isSteal !== undefined)
            url_ += "isSteal=" + encodeURIComponent("" + isSteal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateFileInReceivedQueue(_response);
        });
    }

    protected processUpdateFileInReceivedQueue(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param fileName (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    cancelFileInReceivedQueue(v: string, fileName?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/cancelfile?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCancelFileInReceivedQueue(_response);
        });
    }

    protected processCancelFileInReceivedQueue(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    updateWorkflowStatusToComplete(documentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/{documentId}/complete";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWorkflowStatusToComplete(_response);
        });
    }

    protected processUpdateWorkflowStatusToComplete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    updateWorkflowStatusToRevive(documentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/{documentId}/revive";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWorkflowStatusToRevive(_response);
        });
    }

    protected processUpdateWorkflowStatusToRevive(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    pendingCertifications(documentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/{documentId}/pendingcertifications";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPendingCertifications(_response);
        });
    }

    protected processPendingCertifications(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    documentReceipt(documentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/{documentId}/receipt";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDocumentReceipt(_response);
        });
    }

    protected processDocumentReceipt(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param workFlowStatusId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    documentDataEntry(documentId: number, v: string, workFlowStatusId?: number | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/{documentId}/dataentry?";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (workFlowStatusId !== undefined && workFlowStatusId !== null)
            url_ += "workFlowStatusId=" + encodeURIComponent("" + workFlowStatusId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDocumentDataEntry(_response);
        });
    }

    protected processDocumentDataEntry(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    documentSendToAssignment(documentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/{documentId}/sendtoassignment";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDocumentSendToAssignment(_response);
        });
    }

    protected processDocumentSendToAssignment(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    assignDocument(documentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/{documentId}/assign";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssignDocument(_response);
        });
    }

    protected processAssignDocument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    unAssignDocument(documentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/{documentId}/unassign";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnAssignDocument(_response);
        });
    }

    protected processUnAssignDocument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    stealDocument(documentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/{documentId}/steal";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStealDocument(_response);
        });
    }

    protected processStealDocument(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param workFlowStatusId (optional) 
     * @param isChangeForm (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    changeForm(documentId: number, v: string, workFlowStatusId?: number | null | undefined, isChangeForm?: boolean | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/{documentId}/changeform?";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (workFlowStatusId !== undefined && workFlowStatusId !== null)
            url_ += "workFlowStatusId=" + encodeURIComponent("" + workFlowStatusId) + "&";
        if (isChangeForm === null)
            throw new Error("The parameter 'isChangeForm' cannot be null.");
        else if (isChangeForm !== undefined)
            url_ += "isChangeForm=" + encodeURIComponent("" + isChangeForm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangeForm(_response);
        });
    }

    protected processChangeForm(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param fName (optional) 
     * @param lName (optional) 
     * @param agentId (optional) 
     * @param typeId (optional) 
     * @param companyId (optional) 
     * @param marketerAgentId (optional) 
     * @param uplineAgentId (optional) 
     * @param assignedToUserId (optional) 
     * @param assignedToTeamId (optional) 
     * @param productId (optional) 
     * @param notes (optional) 
     * @param appDate (optional) 
     * @param flag (optional) 
     * @param fileName (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param file (optional) 
     * @param existingFileName (optional) 
     * @return Success
     */
    replaceReceivedandUpdateDocument(v: string, id?: number | undefined, fName?: string | null | undefined, lName?: string | null | undefined, agentId?: number | null | undefined, typeId?: number | undefined, companyId?: number | null | undefined, marketerAgentId?: number | null | undefined, uplineAgentId?: number | null | undefined, assignedToUserId?: number | null | undefined, assignedToTeamId?: number | null | undefined, productId?: number | null | undefined, notes?: string | null | undefined, appDate?: Date | null | undefined, flag?: string | null | undefined, fileName?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, file?: FileParameter | null | undefined, existingFileName?: string | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/replacereceivedandupdatedocument?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (fName !== undefined && fName !== null)
            url_ += "FName=" + encodeURIComponent("" + fName) + "&";
        if (lName !== undefined && lName !== null)
            url_ += "LName=" + encodeURIComponent("" + lName) + "&";
        if (agentId !== undefined && agentId !== null)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (typeId === null)
            throw new Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (marketerAgentId !== undefined && marketerAgentId !== null)
            url_ += "MarketerAgentId=" + encodeURIComponent("" + marketerAgentId) + "&";
        if (uplineAgentId !== undefined && uplineAgentId !== null)
            url_ += "UplineAgentId=" + encodeURIComponent("" + uplineAgentId) + "&";
        if (assignedToUserId !== undefined && assignedToUserId !== null)
            url_ += "AssignedToUserId=" + encodeURIComponent("" + assignedToUserId) + "&";
        if (assignedToTeamId !== undefined && assignedToTeamId !== null)
            url_ += "AssignedToTeamId=" + encodeURIComponent("" + assignedToTeamId) + "&";
        if (productId !== undefined && productId !== null)
            url_ += "ProductId=" + encodeURIComponent("" + productId) + "&";
        if (notes !== undefined && notes !== null)
            url_ += "Notes=" + encodeURIComponent("" + notes) + "&";
        if (appDate !== undefined && appDate !== null)
            url_ += "AppDate=" + encodeURIComponent(appDate ? "" + appDate.toISOString() : "") + "&";
        if (flag !== undefined && flag !== null)
            url_ += "Flag=" + encodeURIComponent("" + flag) + "&";
        if (fileName !== undefined && fileName !== null)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (existingFileName !== null && existingFileName !== undefined)
            content_.append("ExistingFileName", existingFileName.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReplaceReceivedandUpdateDocument(_response);
        });
    }

    protected processReplaceReceivedandUpdateDocument(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param fileTypeId (optional) 
     * @param lastName (optional) 
     * @param agentId (optional) 
     * @param insuredId (optional) 
     * @param companyId (optional) 
     * @param workFlowType (optional) 
     * @param insuredName (optional) 
     * @param workflowStatusId (optional) 
     * @param fileType (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    downloadWorkflowDocs(v: string, fileTypeId?: number | undefined, lastName?: string | null | undefined, agentId?: number | null | undefined, insuredId?: number | null | undefined, companyId?: number | null | undefined, workFlowType?: ShowWorkFlowType | undefined, insuredName?: string | null | undefined, workflowStatusId?: number | null | undefined, fileType?: FileType | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/workflow/v{v}/documents/downloadworkflowdocs?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (fileTypeId === null)
            throw new Error("The parameter 'fileTypeId' cannot be null.");
        else if (fileTypeId !== undefined)
            url_ += "FileTypeId=" + encodeURIComponent("" + fileTypeId) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (agentId !== undefined && agentId !== null)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (insuredId !== undefined && insuredId !== null)
            url_ += "InsuredId=" + encodeURIComponent("" + insuredId) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (workFlowType === null)
            throw new Error("The parameter 'workFlowType' cannot be null.");
        else if (workFlowType !== undefined)
            url_ += "WorkFlowType=" + encodeURIComponent("" + workFlowType) + "&";
        if (insuredName !== undefined && insuredName !== null)
            url_ += "InsuredName=" + encodeURIComponent("" + insuredName) + "&";
        if (workflowStatusId !== undefined && workflowStatusId !== null)
            url_ += "WorkflowStatusId=" + encodeURIComponent("" + workflowStatusId) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "FileType=" + encodeURIComponent("" + fileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadWorkflowDocs(_response);
        });
    }

    protected processDownloadWorkflowDocs(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }
}

export enum ShowWorkFlowType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export interface WorkflowDocumentListModel {
    id?: number;
    date?: Date | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    agentLastName?: string | undefined;
    uplineLastName?: string | undefined;
    userName?: string | undefined;
    flag?: string | undefined;
    companyId?: number | undefined;
    companyName?: string | undefined;
    productId?: number | undefined;
    productName?: string | undefined;
    workFlowStatusId?: number;
    workFlowStatus?: string | undefined;
    agentId?: number | undefined;
    agentName?: string | undefined;
    agentDocCount?: number;
    upLineAgentName?: string | undefined;
    docTypeId?: number | undefined;
    docType?: string | undefined;
    fileTypeId?: number;
    assignedToUser?: string | undefined;
    assignedToUserId?: number | undefined;
    assignedToTeam?: string | undefined;
    assignedToTeamId?: number | undefined;
    noOfDays?: number;
    appDate?: Date | undefined;
    insuredName?: string | undefined;
    recentNoteDate?: Date | undefined;
    recentNoteUserId?: number | undefined;
    submissionReceived?: boolean;
    pendingCertificates?: boolean | undefined;
    isRevived?: boolean;
    hoursDisplayCss?: any | undefined;
    backgroundCss?: string | undefined;
    otherCss?: any | undefined;
    isGrabbedByUser?: boolean;
    canStealOnlyTeamWorkflowApps?: boolean;
    canStealOnlyTeamWorkflowContracts?: boolean;
    assignedUserTeamId?: number | undefined;
    upLineAgentId?: number | undefined;
    marketerAgentId?: number | undefined;
}

export interface WorkflowDocumentSearchRepsonse {
    recordCount?: number;
    emailAllRecords?: WorkflowDocumentListModel[] | undefined;
    data?: WorkflowDocumentListModel[] | undefined;
}

export interface CreateUpdateWorkflowDocumentModel {
    id?: number;
    fName?: string | undefined;
    lName?: string | undefined;
    agentId?: number | undefined;
    typeId?: number;
    companyId?: number | undefined;
    marketerAgentId?: number | undefined;
    uplineAgentId?: number | undefined;
    assignedToUserId?: number | undefined;
    assignedToTeamId?: number | undefined;
    productId?: number | undefined;
    notes?: string | undefined;
    appDate?: Date | undefined;
    flag?: string | undefined;
    fileName?: string | undefined;
}

export interface WorkflowDocumentDetailModel {
    id?: number;
    filename?: string | undefined;
    fName?: string | undefined;
    lName?: string | undefined;
    companyId?: number;
    companyName?: string | undefined;
    fileType?: number | undefined;
    typeId?: number;
    typeName?: string | undefined;
    workflowStatusId?: number;
    workflowStatusType?: string | undefined;
    agentId?: number | undefined;
    agentName?: string | undefined;
    agentFirstName?: string | undefined;
    agentLastName?: string | undefined;
    marketerAgentId?: number | undefined;
    marketerAgentName?: string | undefined;
    marketerAgentFirstName?: string | undefined;
    marketerAgentLastName?: string | undefined;
    uplineAgentId?: number | undefined;
    uplineAgentName?: string | undefined;
    uplineAgentFirstName?: string | undefined;
    uplineAgentLastName?: string | undefined;
    assignedToUserId?: number | undefined;
    userName?: string | undefined;
    userFirstName?: string | undefined;
    userLastName?: string | undefined;
    assignedToTeamId?: number | undefined;
    userTeamName?: string | undefined;
    productId?: number | undefined;
    productName?: string | undefined;
    date?: Date | undefined;
    appDate?: Date | undefined;
    createdDate?: Date;
    pendingCertificates?: boolean | undefined;
    submissionReceived?: boolean | undefined;
    notes?: string | undefined;
    flag?: string | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface DeleteWorkflowDocumentModel {
    notes?: string | undefined;
}

export interface ListItem {
    value?: string | undefined;
    text?: string | undefined;
    selected?: boolean;
}

export interface LookupDetailModel {
    companyList?: ListItem[] | undefined;
    documentTypeList?: ListItem[] | undefined;
    divisionList?: ListItem[] | undefined;
    workflowAssignedToUsersList?: ListItem[] | undefined;
    workflowAssignedToUserTeamList?: ListItem[] | undefined;
    workflowStatusList?: ListItem[] | undefined;
}

export interface WorkflowDocumentCountModel {
    assignedToUserDocumentCount?: number;
    assignedToUserTeamDocumentCount?: number;
    workflowAppsCount?: number;
    workflowContractsCount?: number;
}

export interface WorkflowDocumentCountResponse {
    data?: WorkflowDocumentCountModel;
}

export interface WorkflowNotesResponse {
    id?: number;
    dateCreated?: Date;
    comment?: string | undefined;
    userName?: string | undefined;
}

export interface AddDocumentNoteModel {
    notes?: string | undefined;
}

export interface DownloadFileInReceivedQueueModel {
    filename?: string | undefined;
    pdfData?: string | undefined;
}

export interface DownloadWorkflowDocumentModel {
    filename?: string | undefined;
    pdfData?: string | undefined;
    message?: string | undefined;
}

export interface AgentContactEmailsResponse {
    data?: string[] | undefined;
}

export interface LicenseCommunicationItem {
    type?: string | undefined;
    value?: string | undefined;
    description?: string | undefined;
}

export interface LicenseCommunicationsResponse {
    company?: string | undefined;
    fileType?: string | undefined;
    data?: LicenseCommunicationItem[] | undefined;
}

export interface AddSendToCommentsModel {
    notes?: string | undefined;
    assignedToUserId?: number | undefined;
    assignedToTeamId?: number | undefined;
    workflowStatusId?: number;
    chkSendEmail?: boolean;
    chkMoveToMissingInfo?: boolean;
}

export enum LocationType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export interface DuplicateWorkflowDocumentModel {
    notes?: string | undefined;
}

export enum FileType {
    _0 = 0,
    _1 = 1,
}

export interface ReportFile {
    title?: string | undefined;
    data?: string | undefined;
    contentType?: string | undefined;
    fileName?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}